<template>
  <vs-card>
    <div class="head-card">
      <h3>Total Manpower</h3>
      <vs-spacer></vs-spacer>
      <vs-select
        class="selectExample"
        v-model="select1"
        @change="getDataChart"
        width="80px"
      >
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item, index) in options1"
        />
      </vs-select>
    </div>
    <!-- <br/> -->
    <ChartTotalWork
      v-if="chartData.length > 0"
      :height="170"
      :chartData="chartData"
      :labels="labels"
    />
  </vs-card>
</template>

<script>
import ChartTotalWork from "./ChartTotalWorker.vue";

export default {
  data() {
    return {
      select1: 6,
      options1: [
        { text: "Day", value: 0 },
        { text: "Week", value: 6 },
        { text: "Month", value: 29 },
      ],
      chartData: [],
      labels: [],
      delay:0,
    };
  },
  components: { ChartTotalWork },
  mounted() {
    this.getDataChart();
  },
  methods: {
    async getDataChart() {
      this.chartData = [];
      this.labels = [];
      let dateN = this.$moment(
        new Date().getTime() - this.select1 * 24 * 60 * 60 * 1000
      ).format("YYYY-MM-DD");
      let dateAfter = new Date();
      let dateEnd = this.$moment().format("YYYY-MM-DD");

      let body = {
        start: this.$moment(
          new Date().getTime() - this.select1 * 24 * 60 * 60 * 1000
        ).format("YYYY-MM-DD"),
        end: this.$moment().format("YYYY-MM-DD"),
      };
      console.log(body);
      let res = await this.$API.post("iapc/daily/getinfo", body);
      console.log(res);
      console.log(dateN, this.select1);
      if (res.status == 200) {
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          // console.log(el);
          if (el.date == dateN) {
            this.chartData.push(el.count);
            this.labels.push(dateN);
            dateAfter = new Date(dateN).getTime() + 24 * 60 * 60 * 1000;
            dateN = this.$moment(dateAfter).format("YYYY-MM-DD");
          } else {
            this.chartData.push(0);
            this.labels.push(dateN);
            dateAfter = new Date(dateN).getTime() + 24 * 60 * 60 * 1000;
            dateN = this.$moment(dateAfter).format("YYYY-MM-DD");
            i--;
          }
        }
        // console.log(dateN,dateEnd);

        // this.chartData.push(0);
        // this.labels.push(dateN);
        while (new Date(dateEnd).getTime() > new Date(dateN).getTime()) {
          dateAfter = new Date(dateN).getTime() + 24 * 60 * 60 * 1000;
          dateN = this.$moment(dateAfter).format("YYYY-MM-DD");
          this.chartData.push(0);
          this.labels.push(dateN);
        }
        // console.log("add", this.chartData);
        this.delay = 1
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.head-card {
  display: flex;
}
</style>